import type { MutableRefObject } from 'react';

import type { Element } from '@/domains/productDiscovery/Listings/hooks/useProductsImpressionTracking/interfaces';

import type { ViewedProduct } from '../../useProductsImpressionTracking';

export const itemsViewedCalculator = (
  elements: MutableRefObject<Element[]>,
  viewedProducts: MutableRefObject<ViewedProduct[]>,
  options?: {
    promotedProductModelId?: number;
  },
): number => {
  const { promotedProductModelId } = options || {};

  let sumOfProductCardSpacesTakenByElements = 0;
  if (elements.current.length) {
    sumOfProductCardSpacesTakenByElements = elements.current.reduce(
      (sum, { numberOfProductCardSpaceTakenByElement }) =>
        sum + numberOfProductCardSpaceTakenByElement,
      0,
    );
  }

  const promotedProductInViewedProducts = viewedProducts.current.find(
    (p) => p.product.modelId === promotedProductModelId,
  );

  const itemsViewedNumber =
    viewedProducts.current.length + sumOfProductCardSpacesTakenByElements;

  return promotedProductInViewedProducts
    ? itemsViewedNumber - 1
    : itemsViewedNumber;
};
